// Growth timeline helpers: Saturn returns + personal-year cycle. Pure/deterministic, no AI.

export function ageFromBirthDate(birthDate) {
  if (!birthDate) return null;
  const b = new Date(birthDate);
  if (isNaN(b)) return null;
  const now = new Date();
  let age = now.getFullYear() - b.getFullYear();
  const m = now.getMonth() - b.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < b.getDate())) age -= 1;
  return age;
}

// The three Saturn returns (~every 29.5 years), with status relative to current age.
export function saturnReturns(age) {
  const defs = [
    { n: 1, label: "First Saturn Return", range: [28, 31], center: 29.5,
      theme: "Growing up on your own terms — career, commitment and who you really are." },
    { n: 2, label: "Second Saturn Return", range: [57, 60], center: 58.5,
      theme: "Wisdom and legacy — releasing what no longer fits and owning your authority." },
    { n: 3, label: "Third Saturn Return", range: [86, 89], center: 88,
      theme: "Elderhood — distilling a lifetime into what truly matters." },
  ];
  return defs.map((d) => {
    let status = "upcoming";
    if (age == null) status = "unknown";
    else if (age >= d.range[0] && age <= d.range[1]) status = "now";
    else if (age > d.range[1]) status = "past";
    return { ...d, status };
  });
}

// Which life chapter (between returns) the person is currently in.
export function saturnChapter(age) {
  if (age == null) return null;
  if (age < 28) return { label: "First cycle", note: "laying your foundations (0–29)" };
  if (age <= 31) return { label: "First Saturn Return", note: "a major coming-of-age recalibration" };
  if (age < 57) return { label: "Second cycle", note: "building your mature life (30–57)" };
  if (age <= 60) return { label: "Second Saturn Return", note: "harvest and re-authoring" };
  if (age < 86) return { label: "Third cycle", note: "mastery and legacy (58–86)" };
  return { label: "Third cycle+", note: "elderhood and distillation" };
}

export const PERSONAL_YEAR = {
  1: { title: "Beginnings", theme: "Plant seeds. A fresh 9-year cycle opens — start what matters." },
  2: { title: "Patience", theme: "Slow down, partner up, and let things develop." },
  3: { title: "Expression", theme: "Create, connect and speak your truth — joy and visibility." },
  4: { title: "Foundation", theme: "Build the structures and habits that will hold your future." },
  5: { title: "Change", theme: "Freedom, movement and the unexpected — say yes to life." },
  6: { title: "Responsibility", theme: "Home, love and care — tend to what and whom you cherish." },
  7: { title: "Reflection", theme: "Go inward. Study, rest and listen for deeper truth." },
  8: { title: "Power", theme: "Ambition and reward — step into leadership and abundance." },
  9: { title: "Completion", theme: "Release and forgive. Clear space for the next cycle to begin." },
};
